import 'dayjs/locale/zh-cn'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import locale from 'element-plus/lib/locale/lang/zh-cn'

import '@/config/global'
import 'lin/plugin'
import { filters } from 'lin/filter'
import permissionDirective from 'lin/directive/authorize'

import App from '@/app.vue'
import store from '@/store'
import router from '@/router'

import LinNotify from '@/component/notify'
import LIcon from '@/component/base/icon/lin-icon'
import StickyTop from '@/component/base/sticky-top/sticky-top'
import SourceCode from '@/component/base/source-code/source-code'

import '@/assets/style/index.scss'
import 'element-plus/dist/index.css'
import '@/assets/style/realize/element-variable.scss'
import '@/assets/style/element.css'

import components from "./common/index.js";
// 引入打印插件
// import { hiPrintPlugin } from "vue-plugin-hiprint";
// 关闭客户端连接
// hiPrintPlugin.disAutoConnect()

import * as echarts from 'echarts'
import { debounce } from 'lodash'; // 或自定义防抖函数

const app = createApp(App)

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 100); // 调整防抖时间
    super(callback);
  }
};

app.use(store)
app.use(router)
app.use(ElementPlus, { locale })
app.use(LinNotify, {
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
})

// base 组件注册
app.component('l-icon', LIcon)
app.component('sticky-top', StickyTop)
app.component('source-code', SourceCode)

app.config.globalProperties.$filters = filters
app.config.globalProperties.$echarts = echarts // 全局挂载echarts

app.directive('permission', permissionDirective)
app.use(components);
// 安装插件
// app.use(hiPrintPlugin);
app.mount('#app')

// 设置 App 实例
window.App = app
